<template>
    <div class="panel panel-default form-horizontal">
        <div class="panel-heading">
            <h5 class="pull-left">
                Future Invoicing

                <i class="fa fa-question-circle" v-tooltip.bottom="tooltip"></i>
            </h5>

            <button type="button" class="btn btn-xs btn-black pull-right" @click="display = !display" style="margin-top: 8px">
                <i class="fa fa-search"></i> {{ display ? 'Hide' : 'Show' }}
            </button>

            <div class="clearfix"></div>
        </div>

        <div v-if="display" class="panel-body">
            <number-form-group
                    :value="subscription.price"
                    name="price"
                    label="Price"
                    help-text="The future price of invoices in this subscription."
                    :error="getError('price')"
                    :disabled="missingPermission('admin')"
                    @input="update('price', $event)"
            ></number-form-group>

            <number-form-group
                    :value="subscription.period"
                    name="period"
                    label="Period"
                    help-text="The future period (in months) of invoices in this subscription."
                    :error="getError('period')"
                    :disabled="missingPermission('admin')"
                    @input="update('period', $event)"
            ></number-form-group>

            <number-form-group
                    :value="subscription.closes_after"
                    name="closes_after"
                    label="Closes After"
                    help-text="The future number of days that the subscription will remain active when not paid."
                    :error="getError('closes_after')"
                    @input="update('closes_after', $event)"
            ></number-form-group>

            <number-form-group
                    :value="subscription.seats"
                    name="seats"
                    label="Seats"
                    help-text="The number of seats that the subscription will grant on the portal."
                    :error="getError('seats')"
                    @input="update('seats', $event)"
            ></number-form-group>
        </div>
    </div>
</template>

<script>
    import NumberFormGroup from '@/vendor/forms/FormGroups/Horizontal/Number'
    import Permissions from '@/mixins/Permissions'

    export default {
        components: {NumberFormGroup},

        mixins: [Permissions],

        props: ['subscription', 'errors'],

        model: {
            prop: 'subscription'
        },

        data() {
            return {
                display: false
            }
        },

        computed: {
            tooltip() {
                return {
                    content: '<p>You may use this form for making adjustments to the subscription type that has been selected.</p>',
                    classes: 'help'
                }
            }
        },

        methods: {
            update(key, value) {
                this.$emit('input', {...this.subscription, [key]: value})
            },

            getError(name) {
                return typeof this.errors[name] !== 'undefined' ? this.errors[name][0] : null
            }
        }
    }
</script>
